<template>
  <PageContainer>
    <div
      class="editor-columns"
      id="menuScrollContainer"
    >
      <div class="editor-column">
        <CategoryList
          :busy="false"
          @select="onCategorySelect"
          @modificatorsCategory="(v) => (modificators_category = v)"
          @editCategory="onStartEditCategory"
          ref="categoryList"
        />
      </div>
      <div class="editor-column ml-16">
        <DishList
          :busy="false"
          @edit="showEditUI"
          :category="category"
          @rearrange="onDishListRearrange"
          @select="onDishSelect"
          ref="dishList"
          v-if="category"
        />
      </div>

      <div class="editor-column ml-16">
        <DishTab
          @startEdit="editing_dish = true"
          @finishEdit="editing_dish = false"
          :category="category"
          ref="dishTab"
          v-if="dish && category_products.length"
          @validation="(v) => (menu_valid = v)"
        />
      </div>

      <div
        class="lang"
        v-if="false"
      >
        <h2>{{ $t("menu_editor.languages") }}</h2>
        <div class="lang-list">
          <button
            class="new-lang"
            @click="addNewLanguage"
          ></button>
          <img
            v-for="locale in menu.locales"
            :key="locale"
            :src="`/flags/${locale}.png`"
            :class="{
              'lang-selected': currentLocale == locale,
            }"
            @click="setLocale(locale)"
          />
          <div class="original-locale-divider"></div>
          <img
            :src="`/flags/${menu.original_locale}.png`"
            :class="{
              'lang-selected': !currentLocale,
              'lang-original': true,
            }"
            @click="setLocale(null)"
          />
        </div>
      </div>

      <LanguageModal
        :exclude="menu.locales.concat([menu.original_locale])"
        @select="onLanguageSelect"
        @close="language_modal = false"
        v-if="language_modal"
      />
    </div>

    <div
      class="mt-24"
      v-if="dish"
    >
      <DishSettings
        :showModificators="showing_modificators"
        :category="category"
        @update="tryToSaveMenu"
        @imagesUpdated="onProductImagesUpdated"
      />

      <!-- <ModificatorSettings
        @showModificators="(v) => (showing_modificators = v)"
        @update="tryToSaveMenu"
      /> -->
      <PriceGroupsSettings class="mt-24" />
    </div>

    <DangerConfirmModal
      @confirm="deleteLocale"
      @cancel="deleting_locale = false"
      v-if="deleting_locale"
    >
      {{ $t("menu_editor.confirm_language_delete") }}
    </DangerConfirmModal>

    <InfoModal
      @close="confirmOutOfSync"
      v-if="isEditorOutOfSync"
    >
      <p v-html="$t('dish_settings.sync_warn')"></p>
    </InfoModal>
  </PageContainer>
</template>

<script>
import CategoryList from '@/components/menu/CategoryList.vue'
import DishList from '@/components/menu/DishList.vue'
import DishTab from '@/components/menu/DishTab.vue'
import ModificatorList from '@/components/menu/ModificatorList.vue'
import ModificatorCard from '@/components/menu/ModificatorCard.vue'
import Recommendations from '@/components/menu/Recommendations.vue'
import DishCardOptions from '@/components/menu/DishCardOptions.vue'
import LanguageModal from '@/components/modals/LanguageModal.vue'
import RemoteScroller from '@/components/RemoteScroller.vue'
import ModificatorEditCard from '@/components/menu/ModificatorEditCard.vue'
import DishSettings from '@/components/menu/DishSettings.vue'
import PriceGroupsSettings from '@/components/menu/PriceGroupsSettings.vue'
import InfoModal from '@/components/modals/InfoModal.vue'

export default {
  components: {
    CategoryList,
    DishList,
    DishTab,
    Recommendations,
    LanguageModal,
    DishCardOptions,
    RemoteScroller,
    ModificatorCard,
    ModificatorList,
    ModificatorEditCard,
    DishSettings,
    InfoModal,
    PriceGroupsSettings
  },
  data() {
    return {
      category: null,

      language_modal: false,

      editing_dish: false,

      modificators_category: false,

      selected_modificator: null,
      editing_modificator: false,

      showing_modificators: true,

      adding_locale: false,
      deleting_locale: false,
      locale_to_delete: null,

      menu_valid: true
    }
  },
  methods: {
    onProductImagesUpdated() {
      this.$refs.dishTab.updateImageNonces()
      this.$refs.dishList.updateImageNonces()
    },
    onDishSelect(d) {
      // if (this.editing_dish) {
      //   this.$store.dispatch("menu/updateProduct");
      // }

      this.$store.commit('menu/chooseProduct', d)

      if (this.$store.getters['menu/isLocalizing']) {
        this.$store.commit('menu/postFixModificatorsLocalizations')
      }
    },
    showEditUI() {
      this.$refs.dishTab.showEditUI()
      this.editing_dish = true

      this.$nextTick(() => {
        document.getElementById('dishNameField').focus()
      })
    },
    onLanguageSelect(l) {
      this.language_modal = false

      if (this.adding_locale) {
        this.$store.commit('menu/addLocale', l)
      } else if (!this.menu.original_locale) {
        this.$store.commit('menu/setOriginalLocale', l)
      }

      this.$store.dispatch('menu/save')

      if (!this.adding_locale) {
        this.$store.commit('menu/setCurrentLocale', null)
      } else {
        this.$store.commit('menu/setCurrentLocale', l)
      }
    },
    onCategorySelect(c) {
      this.category = c
      if (this.category_products.length) {
        this.$nextTick(() => {
          this.$refs.dishTab.onEditFinish()
        })
      } else {
        this.$store.commit('menu/chooseProduct', null)
      }
    },
    onSelectModificator(m) {
      this.selected_modificator = m
    },
    onModificatorDeleted() {
      this.selected_modificator = null
    },
    tryToSaveMenu() {
      this.$store.dispatch('menu/save')
    },
    addNewLanguage() {
      this.adding_locale = true
      this.language_modal = true
    },
    setLocale(v) {
      if (v && this.currentLocale == v) {
        this.showDeleteLocaleUI(v)
        return
      }
      this.$store.commit('menu/setCurrentLocale', v)
    },
    showDeleteLocaleUI(loc) {
      this.deleting_locale = true
      this.locale_to_delete = loc
    },
    deleteLocale() {
      this.$store.commit('menu/setCurrentLocale', null)
      this.deleting_locale = false
      this.$store.commit('menu/removeLocale', this.locale_to_delete)
      this.$store.dispatch('menu/save')
    },
    onDishListRearrange() {
      this.$refs.categoryList.hideEditCategoryUI()
    },
    onStartEditCategory() {
      this.$refs.dishList.onFinishAction()
    },
    confirmOutOfSync() {
      this.$store.commit('menu/setOutOfSync', false)
      this.$emit('return')
    }
  },
  mounted() {
    // if (!this.menu.original_locale) {
    //   this.language_modal = true;
    //   this.adding_locale = false;
    // }

    this.$store.commit('menu/setCurrentLocale', null)

    this.$store.commit('menu/chooseProduct', null)

    this.$store.dispatch('stoplist/fetchStoplist')

    if (this.$route.query.product_id) {
      this.$store.commit('menu/chooseProductById', this.$route.query.product_id)
    }
  },
  computed: {
    dish() {
      return this.$store.state.menu.product
    },
    menu() {
      return this.$store.state.menu.current
    },
    category_products() {
      if (!this.category) return []
      return this.$store.getters['menu/productsForCategory'](this.category)
    },
    currentLocale() {
      return this.$store.state.menu.current_locale
    },
    isEditorOutOfSync() {
      return this.$store.state.menu.editor_out_of_sync
    }
  }
}
</script>

<style scoped>
.editor-columns {
  display: flex;
  justify-content: space-between;
}

.editor-column {
  width: 100%;
}
</style>
